import React from "react";
import "./InvestigatorContainer.scss";

const InvestigatorContainer = ({ children }) => {
  return <div className="investigator-container">{children}</div>;
};

export default InvestigatorContainer;
